import GlobalSearchReducer, {
  globalInitialState,
} from "Context/GlobalSearchReducer";
import { createContext, useReducer, useContext } from "react";

const GlobalSearchContext = createContext<any>(globalInitialState);
interface IGlobalSearchProvider {
  children: any;
}
export const GlobalSearchProvider = ({ children }: IGlobalSearchProvider) => {
  const [state, dispatch] = useReducer(GlobalSearchReducer, globalInitialState);

  const saveGlobalSearchData = (globalData: any) => {
    const updatedGlobalSearchData = {
      ...state.globalSearchData,
      ...globalData,
    };
    dispatch({
      type: "SAVE_GLOBALSEARCHDATA",
      payload: { ...updatedGlobalSearchData },
    });
  };

  const removeGlobalSearchData = (globalData: any) => {
    const updatedGlobalSearchData = { ...state.globalSearchData };
    delete updatedGlobalSearchData[globalData];
    dispatch({
      type: "REMOVE_GLOBALSEARCHDATA",
      payload: { ...updatedGlobalSearchData },
    });
  };
  const clearGlobalSearchData = () => {
    dispatch({
      type: "CLEAR_GLOBALSEARCHDATA",
    });
  };
  const value = {
    globalSearchData: state.globalSearchData,
    saveGlobalSearchData,
    removeGlobalSearchData,
    clearGlobalSearchData,
  };
  return (
    <GlobalSearchContext.Provider value={value}>
      {children}
    </GlobalSearchContext.Provider>
  );
};

const useGlobalSearchContext = () => {
  const context = useContext(GlobalSearchContext);

  if (context === undefined) {
    throw new Error(
      "useGlobalSearchContext must be used within GlobalSearchContext"
    );
  }

  return context;
};

export default useGlobalSearchContext;
